import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs';

if (!customElements.get('retreat-events-slider')) {
  class RetreatEventsSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.init();
    }
  
    init() {
      // Wait for DOM to be ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setupSlider());
      } else {
        this.setupSlider();
      }
    }
  
    setupSlider() {
      const sliderContainer = this.querySelector('.retreat-events__slider');
      const prevBtn = this.querySelector('.retreat-events__nav-btn--prev');
      const nextBtn = this.querySelector('.retreat-events__nav-btn--next');
  
      if (!sliderContainer) return;
  
      // Load Swiper dynamically
      this.loadSwiper().then(() => {
        this.slider = new Swiper(sliderContainer, {
          slidesPerView: 1,
          spaceBetween: 8,
          loop: false,
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
          },
          pagination: {
            el: '.retreat-events__pagination',
            clickable: true,
          }
        });
      });
    }
  
    loadSwiper() {
      return new Promise((resolve) => {
        // Check if Swiper is already loaded
        if (window.Swiper) {
          resolve();
          return;
        }
  
        // Load Swiper CSS if not already loaded
        if (!document.querySelector('link[href*="swiper"]')) {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.css';
          document.head.appendChild(link);
        }
  
        // Load Swiper JS
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js';
        script.onload = resolve;
        document.head.appendChild(script);
      });
    }
  
    disconnectedCallback() {
      if (this.slider) {
        this.slider.destroy();
      }
    }
  }
  
  // Register the web component
  customElements.define('retreat-events-slider', RetreatEventsSlider);
}